import { render, staticRenderFns } from "./changeOwnership.vue?vue&type=template&id=188bc79c&scoped=true"
import script from "./changeOwnership.vue?vue&type=script&lang=js"
export * from "./changeOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188bc79c",
  null
  
)

export default component.exports